import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';


export default class FolderCard extends React.Component {

  render(){

    return (
      <Box>
        <Box>
          <Typography variant="h6" gutterBottom style={{display: 'inline-block'}}>
            Folder &nbsp;
          </Typography>
          <Typography variant="body1" gutterBottom style={{display: 'inline-block'}}>
            {(this.props.folderName)?"- "+this.props.folderName:"- Unfiled items"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="h6" gutterBottom style={{display: 'inline-block'}}>
            Notes &nbsp;
          </Typography>
          <Typography variant="body1" gutterBottom style={{display: 'inline-block'}}>
            { (typeof this.props.data.notes === 'undefined')?" - N/A":""}
          </Typography>

        </Box>
        <Typography variant="body2" gutterBottom>
          {this.props.data.notes}
        </Typography>
      </Box>
    );
  }
}
